<h2 mat-dialog-title>
  Nulstil 2-faktor besked
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <div fxLayout="row">
    <mat-form-field class="w-100">
      <mat-label>Besked til bruger.</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                [formControl]="body"
                cdkAutosizeMaxRows="25"
      ></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="confirm()">Nulstil og send</button>
</mat-dialog-actions>
